import { BASE_URL } from "../configs";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios"

export async function getContacts({ q, page, perPage, clientId }) {
    let url = `${BASE_URL}/api/contact?`;
    url += getQueryParamsString({ q, page, perPage, clientId });

    const res = await axiosInstance.get(url)
    return res.data.Data;
}
